import { ref } from 'vue';

export enum State {

    // voordat alles ingeladen is
    Hidden = 'hidden',

    // wanneer alles geladen is
    Minimized = 'minimized',

    // zodra de chat gestart is
    Opened = 'opened',
}

const state = ref(State.Hidden);
const showStartChatOverlay = ref(true);
const showPrivacyStatementOverlay = ref(false);
const agreedToPrivacyStatement = ref(false);

export default function useWidgetState() {
    return {
        state,
        showStartChatOverlay,
        showPrivacyStatementOverlay,
        agreedToPrivacyStatement,
    };
}
